import { isBot } from "./utils/BotUtils";

export const AnalyticsTags = (tags: string[]) => {
  const windowWidth = window && window.innerWidth ? window.innerWidth : 0;
  const isMobile = windowWidth < 768;
  const currency = window.__litium.preloadState.cart.currency;
  const bot = isBot();
  const commonTags = [
    window.__litium.isLoggedIn ? "loggedIn" : "notLoggedIn",
    isMobile ? "mobile" : "desktop",
    bot ? "bot" : "noBot",
    "currency_" + currency,
  ];

  return [...tags, ...commonTags];
};
